import { render, staticRenderFns } from "./ProductsWrapper.vue?vue&type=template&id=6b605917&scoped=true"
import script from "./ProductsWrapper.vue?vue&type=script&lang=js"
export * from "./ProductsWrapper.vue?vue&type=script&lang=js"
import style0 from "./ProductsWrapper.vue?vue&type=style&index=0&id=6b605917&prod&lang=scss&module=true&scoped=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "6b605917",
  null
  
)

export default component.exports